import { createFromIconfontCN } from '@ant-design/icons';

/**
 * @link https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=2741043
 * @example <MyIcon type="icon-fill_logon_camera" />
 */
const IconFont = createFromIconfontCN({
  scriptUrl:
    'https://static.huolala.cn/image/a7ac164900942131634de7e267fd3ed5c0c90fd7.js',
});

export default IconFont;
